#import "./StaffTrainingModuleFields.graphql"

mutation RecordTrainingVideoProgress($moduleId: ID!, $percent: Int!) {
  recordTrainingVideoProgress(
    input: { moduleId: $moduleId, percent: $percent }
  ) {
    trainingModule {
      ...StaffTrainingModuleFields
    }
  }
}
